import React, { Component } from "react";
import { Modal, Button, Row, Col, Badge } from "react-bootstrap";
import gql from "graphql-tag";
import { withApollo } from "react-apollo";
import { withRouter } from "react-router-dom";
import * as compose from "lodash.flowright";
import * as Cookies from "es-cookie";
import "./_addEntryModal.scss";
import { defaultBranchValue } from "../../../utils/branchScope";
const GET_DOCUMENT_TYPES = gql`
  query getDocumentTypes {
    getDocumentTypes {
      id
      document_types
      estatus
    }
  }
`;

const GET_BRANCHES = gql`
    query getBranches($institution_id: Int!) {
        getBranches(institution_id: $institution_id) {
            id
            branch_name
            sections {
                id
                class_id
                stream_id
                section_name
            }
        }
    }
`;

const GET_CLASSES = gql`
    query($id: Int) {
        getExamClasses(id: $id) {
            id
            class
        }
    }
`;

const GET_STREAMS = gql`
    query {
        getStreams {
            id
            stream
        }
    }
`;

// Classes that require a stream selection (e.g. Intermediate 1st/2nd year)
const STREAM_CLASS_IDS = [15, 16];
const isStreamClass = (classId) => STREAM_CLASS_IDS.includes(parseInt(classId));

const GET_STUDENTS = gql`
    query($institute_id: Int, $class_id: Int) {
        getNewEducationalStudents(institute_id: $institute_id, class_id: $class_id) {
            student_id
            student_name
            roll_no
            section_id
        }
    }
`;



class AddEntryModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            // dropdown data — same sources as certificate module
            branches:    [],   // getBranches  → { id, branch_name, sections[{id,class_id,stream_id,section_name}] }
            getClasses:  [],   // getExamClasses → { id, class }
            allStreams:  [],   // getStreams → { id, stream }
            allStudents: [],   // getNewEducationalStudents → { student_id, student_name, roll_no, branch_id, class_id, section_id }

            // form selections
            branch:    defaultBranchValue(""),
            className: "",
            stream:    "",
            section:   "",
            admissionNo:  "",
            studentName:  "",
            selectedStudentId: "",

            // documents
            docStatus:    {},
            allDocuments: [],

            // duplicate guard
            duplicateStudentError: null,

            // in-form notification (edit modal banner)
            saveNotification: null, // { type: 'success'|'error', message: string }
            saving: false,

            // top fixed popup (inline / entry tab)
            topPopup: null,  // { type: 'success'|'error', message: string }
            _topPopupTimer: null,
        };
    }

    componentDidMount() {
        this.getBranches();
        this.getClasses();
        this.getStreamsList();
        this.getDocumentTypes();
    }

    getDocumentTypes = async () => {
        try {
            const result = await this.props.client.query({
                query: GET_DOCUMENT_TYPES,
                fetchPolicy: "network-only",
            });
            const docTypes = result.data.getDocumentTypes || [];
            this.setState({
                allDocuments: docTypes.map(d => d.document_types)
            });
        } catch (e) {
            console.error(e);
        }
    };

    // ── Normalise submitted/pending/returned name lists (string | JSON | array) ──
    parseDocNames = (raw) => {
        if (!raw) return [];
        if (Array.isArray(raw)) return raw.filter(Boolean);
        const s = String(raw).trim();
        if (!s) return [];
        try {
            const parsed = JSON.parse(s);
            return Array.isArray(parsed) ? parsed.filter(Boolean) : s.split(',').map(x => x.trim()).filter(Boolean);
        } catch {
            return s.split(',').map(x => x.trim()).filter(Boolean);
        }
    };

    // ── Parse a "||"-separated comment field → {docName: comment} ──
    parseCommentMap = (raw, docNames = []) => {
        if (raw === null || raw === undefined) return {};
        if (Array.isArray(raw)) {
            const map = {};
            docNames.forEach((name, i) => { if (raw[i]) map[name] = String(raw[i]); });
            return map;
        }
        if (typeof raw === 'object') return raw;
        const s = String(raw).trim();
        if (!s) return {};
        try {
            const parsed = JSON.parse(s);
            if (Array.isArray(parsed)) {
                const map = {};
                docNames.forEach((name, i) => { if (parsed[i]) map[name] = String(parsed[i]); });
                return map;
            }
            if (parsed && typeof parsed === 'object') return parsed;
        } catch {}
        // Backend returns "||"-separated string
        const parts = s.split('||').map(x => x.trim());
        const map = {};
        docNames.forEach((name, i) => { if (parts[i]) map[name] = parts[i]; });
        return map;
    };

    componentDidUpdate(prevProps) {
        if (this.props.show && !prevProps.show && !this.props.editMode) {
            this.resetForm();
        }
        if (this.props.editStudent && this.props.editStudent !== prevProps.editStudent) {
            const student = this.props.editStudent;

            // ── Build docStatus from the three name lists in the history record ──
            const submittedNames = this.parseDocNames(student.submitted_names);
            const pendingNames   = this.parseDocNames(student.pending_names);
            const returnedNames  = this.parseDocNames(student.returned_names);

            // Each comment field is parallel to its own names array
            const collectedMap = this.parseCommentMap(student.collected_comments, submittedNames);
            const pendingMap   = this.parseCommentMap(student.pending_comments,   pendingNames);
            const returnMap    = this.parseCommentMap(student.return_comments,    returnedNames);

            const docStatus = {};

            // Pending first (lowest priority) so submitted/returned overwrite if overlap
            pendingNames.forEach(name => {
                docStatus[name] = { assigned: true, collected: false, returned: false,
                    collected_comments: pendingMap[name] || '', return_comments: '' };
            });
            submittedNames.forEach(name => {
                docStatus[name] = { assigned: true, collected: true, returned: false,
                    collected_comments: collectedMap[name] || '', return_comments: '' };
            });
            returnedNames.forEach(name => {
                docStatus[name] = { assigned: true, collected: true, returned: true,
                    collected_comments: '', return_comments: returnMap[name] || '' };
            });

            this.setState({
                // Use IDs so the disabled <select> shows the correct option
                branch:      String(student.branch_id  || ''),
                className:   String(student.class_id   || ''),
                stream:      String(student.stream_id  || ''),
                section:     String(student.section_id || ''),
                admissionNo: student.admission_no  || '',
                studentName: student.student_name  || '',
                docStatus,
                saveNotification: null,
            });
        }
    }

    getBranches = async () => {
        try {
            const instIdStr = Cookies.get("institutionid") || Cookies.get("institute_id") || "0";
            const institution_id = parseInt(instIdStr, 10);
            if (!institution_id) return;
            const result = await this.props.client.query({
                query: GET_BRANCHES,
                variables: { institution_id },
                fetchPolicy: "network-only",
            });
            this.setState({ branches: result.data.getBranches || [] });
        } catch { }
    };

    getClasses = async () => {
        try {
            const result = await this.props.client.query({
                query: GET_CLASSES,
                variables: { id: 1 },
                fetchPolicy: "network-only",
            });
            this.setState({ getClasses: result.data.getExamClasses || [] });
        } catch { }
    };

    getStreamsList = async () => {
        try {
            const result = await this.props.client.query({
                query: GET_STREAMS,
                fetchPolicy: "network-only",
            });
            this.setState({ allStreams: result.data.getStreams || [] });
        } catch { }
    };

    /* ── Streams available in the selected branch+class (only for stream classes) ── */
    getStreamOptions = () => {
        const { branches, branch, className, allStreams } = this.state;
        if (!isStreamClass(className)) return [];
        const branchObj = branches.find(b => String(b.id) === String(branch));
        const streamIds = [...new Set(
            (branchObj?.sections || [])
                .filter(s => String(s.class_id) === String(className) && s.stream_id)
                .map(s => String(s.stream_id))
        )];
        return streamIds
            .map(sid => allStreams.find(st => String(st.id) === String(sid)))
            .filter(Boolean);
    };

    getStudents = async (class_id) => {
        if (!class_id) { this.setState({ allStudents: [] }); return; }
        try {
            const institute_id = parseInt(Cookies.get('institutionid'));
            if (!institute_id) return;
            const result = await this.props.client.query({
                query: GET_STUDENTS,
                variables: { institute_id, class_id: parseInt(class_id, 10) },
                fetchPolicy: "network-only",
            });
            const students = result.data.getNewEducationalStudents || [];
            this.setState({ allStudents: students });
        } catch (e) { console.error("[getStudents]", e); }
    };

    /* ── Cert module: classOpts — classes that exist in selected branch's sections ── */
    getFilteredClasses = () => {
        const { branches, getClasses, branch } = this.state;
        const branchObj = branches.find(b => String(b.id) === String(branch));
        const classIds = branchObj
            ? [...new Set(branchObj.sections.map(s => String(s.class_id)))]
            : [];
        return getClasses
            .filter(c => classIds.includes(String(c.id)))
            .sort((a, b) => Number(a.id) - Number(b.id));
    };

    /* ── Cert module: sectionOpts — sections in branch filtered by class (and stream, for stream classes) ── */
    getFilteredSections = () => {
        const { branches, branch, className, stream } = this.state;
        const branchObj = branches.find(b => String(b.id) === String(branch));
        return (branchObj?.sections || [])
            .filter(s => String(s.class_id) === String(className))
            .filter(s => !isStreamClass(className) || String(s.stream_id) === String(stream))
            .sort((a, b) => a.section_name.localeCompare(b.section_name));
    };

    resetForm = () => {
        this.setState({
            branch:                defaultBranchValue(""),
            className:             "",
            stream:                "",
            section:               "",
            admissionNo:           "",
            studentName:           "",
            selectedStudentId:     "",
            docStatus:             {},
            duplicateStudentError: null,
            saveNotification:      null,
            saving:                false,
        });
        this.getDocumentTypes();
    };

    showTopPopup = (type, message) => {
        // Clear any running timer
        if (this.state._topPopupTimer) clearTimeout(this.state._topPopupTimer);
        const timer = setTimeout(
            () => this.setState({ topPopup: null, _topPopupTimer: null }),
            3000
        );
        this.setState({ topPopup: { type, message }, _topPopupTimer: timer });
    };

    dismissTopPopup = () => {
        if (this.state._topPopupTimer) clearTimeout(this.state._topPopupTimer);
        this.setState({ topPopup: null, _topPopupTimer: null });
    };

    handleChange = (e) => {
        const { name, value } = e.target;
        const next = { [name]: value, saveNotification: null };

        // ── cascade resets ──
        if (name === "branch") {
            next.className         = "";
            next.stream            = "";
            next.section           = "";
            next.selectedStudentId = "";
            next.admissionNo       = "";
            next.studentName       = "";
            next.docStatus         = {};
            next.allStudents       = [];
        }

        if (name === "className") {
            next.stream            = "";
            next.section           = "";
            next.selectedStudentId = "";
            next.admissionNo       = "";
            next.studentName       = "";
            next.docStatus         = {};
            next.allStudents       = [];
            if (value) this.getStudents(value);
        }

        if (name === "stream") {
            next.section           = "";
            next.selectedStudentId = "";
            next.admissionNo       = "";
            next.studentName       = "";
            next.docStatus         = {};
        }

        if (name === "section") {
            next.selectedStudentId = "";
            next.admissionNo       = "";
            next.studentName       = "";
            next.docStatus         = {};
        }

        if (name === "selectedStudentId" && value) {
            const studentInfo = this.state.allStudents.find(
                s => String(s.student_id) === String(value)
            );
            next.studentName = studentInfo?.student_name || "";
            next.admissionNo = studentInfo?.roll_no     || "";
            next.docStatus   = {};

            // ── Duplicate guard: check against already-saved student IDs ──
            const existingIds = this.props.existingStudentIds || [];
            if (existingIds.includes(String(value))) {
                next.duplicateStudentError =
                    `"${studentInfo?.student_name || 'This student'}" already has a document entry. Use the Edit button in History tab to update their records.`;
            } else {
                next.duplicateStudentError = null;
            }
        }

        if (name === "selectedStudentId" && !value) {
            next.duplicateStudentError = null;
        }

        this.setState(next);
    };

    handleAssignedToggle = (doc) => {
        this.setState(prev => {
            const current = prev.docStatus[doc] || { assigned: false, collected: false, returned: false, collected_comments: "", return_comments: "" };
            const newAssigned = !current.assigned;
            return {
                docStatus: {
                    ...prev.docStatus,
                    [doc]: {
                        ...current,
                        assigned: newAssigned,
                        collected: newAssigned ? current.collected : false,
                        returned: newAssigned ? current.returned : false
                    }
                }
            };
        });
    };

    handleCollectedToggle = (doc) => {
        this.setState(prev => {
            const current = prev.docStatus[doc] || { assigned: false, collected: false, returned: false, collected_comments: "", return_comments: "" };
            const newCollected = !current.collected;
            return {
                docStatus: {
                    ...prev.docStatus,
                    [doc]: {
                        ...current,
                        collected: newCollected,
                        returned: newCollected ? current.returned : false
                    }
                }
            };
        });
    };

    handleReturnedToggle = (doc) => {
        this.setState(prev => {
            const current = prev.docStatus[doc] || { assigned: false, collected: false, returned: false, collected_comments: "", return_comments: "" };
            return {
                docStatus: {
                    ...prev.docStatus,
                    [doc]: {
                        ...current,
                        returned: !current.returned
                    }
                }
            };
        });
    };

    handleCommentChange = (doc, field, value) => {
        this.setState(prev => {
            const current = prev.docStatus[doc] || { assigned: false, collected: false, returned: false, collected_comments: "", return_comments: "" };
            return {
                docStatus: {
                    ...prev.docStatus,
                    [doc]: { ...current, [field]: value }
                }
            };
        });
    };


    setNotification = (type, message) => {
        this.setState({ saveNotification: { type, message }, saving: false });
        // Auto-dismiss: success 2.5 s, info 4 s, nochange 6 s
        const delay = type === 'success' ? 2500 : type === 'info' ? 4000 : type === 'nochange' ? 6000 : 0;
        if (delay) {
            setTimeout(() => this.setState(prev =>
                prev.saveNotification && prev.saveNotification.type === type ? { saveNotification: null } : null
            ), delay);
        }
    };

    handleSave = async () => {
        const { branch, className, stream, section, selectedStudentId, docStatus, duplicateStudentError } = this.state;
        const { editMode, onSave } = this.props;

        if (!editMode) {
            if (!branch) {
                this.setNotification('error', 'Please select a Branch before saving.');
                return;
            }
            if (!className) {
                this.setNotification('error', 'Please select a Class before saving.');
                return;
            }
            if (isStreamClass(className) && !stream) {
                this.setNotification('error', 'Please select a Stream before saving.');
                return;
            }
            if (!section) {
                this.setNotification('error', 'Please select a Section before saving.');
                return;
            }
            if (!selectedStudentId) {
                this.setNotification('error', 'Please select a Student before saving.');
                return;
            }
            // ── Duplicate guard ──
            if (duplicateStudentError) {
                this.setNotification('error', 'Cannot save: this student already has a document entry. Use the Edit button in History to update.');
                return;
            }
        }

        const hasAssigned = Object.values(docStatus).some(s => s.assigned);
        if (!hasAssigned) {
            this.setNotification('error', 'Please select at least one document before saving.');
            return;
        }

        this.setState({ saving: true, saveNotification: null });

        const result = await onSave(this.state);

        if (result && result.noChanges) {
            // No changes — stay open, show error-style banner
            this.setNotification('nochange', 'There is no updated data.');

        } else if (!result || result.ok !== false) {
            // Success — show message, then redirect to Documents History.
            // onHide for inline mode navigates to /document-services/history;
            // for edit mode it closes the modal (history view is already underneath).
            const msg = (result && result.message) || 'Saved successfully!';
            this.showTopPopup('success', msg);
            this.setState({ saving: false });
            setTimeout(() => {
                this.resetForm();
                this.props.onHide();
            }, 1000);

        } else {
            // Error — keep fields intact so the user can fix and retry
            this.setNotification('error', result.message || 'Failed to save. Please try again.');
        }
    };

    render() {

        const {
            branches, allStudents,
            branch, className, stream, section,
            admissionNo, studentName, selectedStudentId,
            docStatus,
            allDocuments,
            duplicateStudentError,
            saveNotification,
            saving,
            topPopup,
        } = this.state;

        let numCollected = 0;
        let numAssigned = 0;
        Object.values(docStatus).forEach(s => {
            if (s.collected) numCollected++;
            if (s.assigned)  numAssigned++;
        });

        const { show, onHide, editMode, onSave, inline } = this.props;

        /* ── Cert module dropdown derivation ── */
        const filteredClasses  = this.getFilteredClasses();
        const streamOptions    = this.getStreamOptions();
        const showStream       = isStreamClass(className);
        const filteredSections = this.getFilteredSections();

        // Filter by section_id — allStudents loaded from getNewEducationalStudents on mount
        const studentOpts = allStudents
            .filter(s => section && String(s.section_id) === String(section))
            .sort((a, b) => (a.student_name || "").localeCompare(b.student_name || ""));

        // Keep original order — sorting by status causes rows to jump
        // position on every checkbox click, making it look like the wrong row was selected
        const sortedDocuments = [...allDocuments];

        // Show documents only after all required dropdowns are filled AND no duplicate error (new-entry mode)
        const showDocuments = editMode || !!(branch && className && (!showStream || stream) && section && selectedStudentId && !duplicateStudentError);

        const body = (
            <>

                {/* ── TOP FIXED POPUP (inline / entry tab) ── */}
                {topPopup && (
                    <div className={`ade-top-popup popup-${topPopup.type}`}>
                        <div className="ade-top-popup-inner">
                            <div className={`ade-top-popup-icon icon-${topPopup.type}`}>
                                <i className={`fas ${topPopup.type === 'success' ? 'fa-check-circle' : 'fa-exclamation-triangle'}`} />
                            </div>
                            <div className="ade-top-popup-text">
                                <div className="ade-top-popup-title">
                                    {topPopup.type === 'success' ? 'Entry Saved Successfully!' : 'Unable to Save'}
                                </div>
                                <div className="ade-top-popup-msg">{topPopup.message}</div>
                            </div>
                            <button className="ade-top-popup-close" onClick={this.dismissTopPopup}>×</button>
                        </div>
                        <div className={`ade-top-popup-bar bar-${topPopup.type}`} />
                    </div>
                )}

                {/* ── HEADER ── */}
                <div className="ade-header">
                    <div className="ade-header-icon">
                        <i className={`fas ${editMode ? "fa-edit" : "fa-plus"}`} />
                    </div>
                    <div>
                        <div className="ade-header-title">
                            {editMode ? "Update Student Documents" : "Add Student Documents"}
                        </div>
                        <div className="ade-header-sub">
                            {editMode ? "Edit document submission records" : "Add new document entry for a student"}
                        </div>
                    </div>
                    {editMode && (
                        <button className="ade-close-btn" onClick={onHide} title="Close">
                            ×
                        </button>
                    )}
                </div>

                <div className="ade-body">

                    {/* ── NOTIFICATION BANNER ── */}
                    {saveNotification && (() => {
                        const cfg = {
                            success:  { bg: '#f0fdf4', border: '#86efac', iconBg: '#16a34a', icon: 'fa-check-circle',        titleColor: '#14532d', msgColor: '#166534', title: 'Entry Saved Successfully!'  },
                            info:     { bg: '#eff6ff', border: '#93c5fd', iconBg: '#2563eb', icon: 'fa-info-circle',          titleColor: '#1e3a8a', msgColor: '#1d4ed8', title: 'No Changes Detected'         },
                            nochange: { bg: '#fef2f2', border: '#fca5a5', iconBg: '#dc2626', icon: 'fa-times-circle',         titleColor: '#991b1b', msgColor: '#b91c1c', title: 'No Changes Detected'         },
                            error:    { bg: '#fef2f2', border: '#fca5a5', iconBg: '#ef4444', icon: 'fa-exclamation-triangle', titleColor: '#991b1b', msgColor: '#b91c1c', title: 'Unable to Save'               },
                        }[saveNotification.type] || {};
                        return (
                            <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12, background: cfg.bg, border: `1.5px solid ${cfg.border}`, borderRadius: 12, padding: '13px 16px', marginBottom: 20 }}>
                                <div style={{ width: 34, height: 34, borderRadius: 9, flexShrink: 0, background: cfg.iconBg, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <i className={`fas ${cfg.icon}`} style={{ color: '#fff', fontSize: 14 }} />
                                </div>
                                <div style={{ flex: 1 }}>
                                    <div style={{ fontWeight: 700, fontSize: 13, color: cfg.titleColor, marginBottom: 2 }}>{cfg.title}</div>
                                    <div style={{ fontSize: 12, color: cfg.msgColor, lineHeight: 1.5 }}>{saveNotification.message}</div>
                                </div>
                                <button onClick={() => this.setState({ saveNotification: null })} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#9ca3af', fontSize: 20, lineHeight: 1, padding: 0, marginLeft: 4, flexShrink: 0 }}>×</button>
                            </div>
                        );
                    })()}

                    {/* ── STUDENT INFO ── */}
                    <div className="ade-section">

                        <div className="ade-section-head">
                            <div className="ade-section-dot blue" />
                            <span>Student Information</span>
                        </div>

                        <Row>

                            <Col md={3} sm={6} xs={12}>
                                <div className="ade-field">
                                    <label className="ade-label">
                                        <i className="fas fa-code-branch" /> Branch
                                    </label>
                                    <select
                                        className="ade-select"
                                        name="branch"
                                        value={branch}
                                        onChange={this.handleChange}
                                        disabled={editMode}
                                    >
                                        <option value="">-- Select Branch --</option>
                                        {branches.map(b => (
                                            <option key={b.id} value={String(b.id)}>{b.branch_name}</option>
                                        ))}
                                    </select>
                                </div>
                            </Col>

                            <Col md={3} sm={6} xs={12}>
                                <div className="ade-field">
                                    <label className="ade-label">
                                        <i className="fas fa-layer-group" /> Class
                                    </label>
                                    <select
                                        className="ade-select"
                                        name="className"
                                        value={className}
                                        onChange={this.handleChange}
                                        disabled={editMode || !branch}
                                    >
                                        <option value="">-- Select Class --</option>
                                        {filteredClasses.map(c => (
                                            <option key={c.id} value={String(c.id)}>{c.class}</option>
                                        ))}
                                    </select>
                                </div>
                            </Col>

                            {showStream && (
                                <Col md={3} sm={6} xs={12}>
                                    <div className="ade-field">
                                        <label className="ade-label">
                                            <i className="fas fa-stream" /> Stream
                                        </label>
                                        <select
                                            className="ade-select"
                                            name="stream"
                                            value={stream}
                                            onChange={this.handleChange}
                                            disabled={editMode || !className}
                                        >
                                            <option value="">-- Select Stream --</option>
                                            {streamOptions.map(st => (
                                                <option key={st.id} value={String(st.id)}>{st.stream}</option>
                                            ))}
                                        </select>
                                    </div>
                                </Col>
                            )}

                            <Col md={3} sm={6} xs={12}>
                                <div className="ade-field">
                                    <label className="ade-label">
                                        <i className="fas fa-users" /> Section
                                    </label>
                                    <select
                                        className="ade-select"
                                        name="section"
                                        value={section}
                                        onChange={this.handleChange}
                                        disabled={editMode || !className || (showStream && !stream)}
                                    >
                                        <option value="">-- Select Section --</option>
                                        {filteredSections.map(s => (
                                            <option key={s.id} value={String(s.id)}>{s.section_name}</option>
                                        ))}
                                    </select>
                                </div>
                            </Col>

                            {!editMode && (
                                <Col md={3} sm={6} xs={12} className="mb-3">
                                    <div className="ade-field">
                                        <label className="ade-label">
                                            <i className="fas fa-user-graduate" /> Select Student
                                        </label>
                                        <select
                                            className="ade-select"
                                            name="selectedStudentId"
                                            value={selectedStudentId}
                                            onChange={this.handleChange}
                                            disabled={editMode || !section}
                                            style={duplicateStudentError ? { borderColor: '#ef4444', boxShadow: '0 0 0 3px rgba(239,68,68,0.12)' } : {}}
                                        >
                                            <option value="">-- Select Student --</option>
                                            {studentOpts.map(s => (
                                                <option key={s.student_id} value={String(s.student_id)}>
                                                    {s.roll_no ? `${s.roll_no} - ${s.student_name}` : s.student_name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </Col>
                            )}

                            {/* ── Duplicate student error banner ── */}
                            {!editMode && duplicateStudentError && (
                                <Col xs={12}>
                                    <div style={{
                                        display: 'flex',
                                        alignItems: 'flex-start',
                                        gap: 12,
                                        background: '#fef2f2',
                                        border: '1.5px solid #fca5a5',
                                        borderRadius: 10,
                                        padding: '12px 16px',
                                        marginBottom: 8,
                                    }}>
                                        <div style={{
                                            width: 32, height: 32, background: '#ef4444', borderRadius: 8,
                                            display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
                                        }}>
                                            <i className="fas fa-exclamation-triangle" style={{ color: '#fff', fontSize: 13 }} />
                                        </div>
                                        <div>
                                            <div style={{ fontWeight: 700, fontSize: 13, color: '#991b1b', marginBottom: 3 }}>
                                                Duplicate Entry Detected
                                            </div>
                                            <div style={{ fontSize: 12, color: '#b91c1c', lineHeight: 1.5 }}>
                                                {duplicateStudentError}
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            )}

                            {editMode && (
                                <Col md={3} sm={12} xs={12}>
                                    <div className="ade-field">
                                        <label className="ade-label">
                                            <i className="fas fa-user-graduate" /> Student
                                        </label>
                                        <select className="ade-select" disabled>
                                            <option>
                                                {admissionNo ? `${admissionNo} - ${studentName}` : studentName}
                                            </option>
                                        </select>
                                    </div>
                                </Col>
                            )}

                        </Row>

                    </div>

                    {/* ── DOCUMENTS ── */}
                    {showDocuments && <div className="ade-section">

                        <div className="ade-section-head">
                            <div className="ade-section-dot green" />
                            <span>Documents</span>
                            <span className="ade-doc-count">{numAssigned} assigned</span>
                        </div>

                        {/* ── Single-line document table ── */}
                        <div className="ade-doc-table-wrap">

                            {/* Table Header */}
                            <div className={`ade-doc-tbl-head${editMode ? " with-return" : ""}`}>
                                <div className="ade-dth ade-dth-sno">S.No</div>
                                <div className="ade-dth ade-dth-doc">Document Name</div>
                                <div className="ade-dth ade-dth-check">Submitted</div>
                                <div className="ade-dth ade-dth-comment">Remarks</div>
                                <div className="ade-dth ade-dth-status">Status</div>
                                {editMode && <div className="ade-dth ade-dth-return">Return Type</div>}
                            </div>

                            {/* Document Rows */}
                            {sortedDocuments.map((doc, index) => {
                                const status = docStatus[doc] || {
                                    assigned: false, collected: false, returned: false,
                                    collected_comments: "", return_comments: "",
                                };
                                const isAssigned = status.assigned;
                                const isCollected = status.collected;
                                const isReturned = status.returned;

                                return (
                                    <div
                                        key={index}
                                        className={[
                                            "ade-doc-row-line",
                                            isCollected ? "row-collected" : isAssigned ? "row-pending" : "row-neutral",
                                            editMode ? "with-return" : "",
                                        ].filter(Boolean).join(" ")}
                                    >

                                        {/* Serial Number */}
                                        <div className="ade-drl-sno">{index + 1}</div>

                                        {/* Document Name + Mandatory (cert) Toggle */}
                                        <div
                                            className="ade-drl-name ade-drl-name-clickable"
                                            onClick={() => this.handleAssignedToggle(doc)}
                                            title={isAssigned ? "Remove from mandatory" : "Mark as mandatory"}
                                        >
                                            <button
                                                type="button"
                                                className={`ade-cert-btn${isAssigned ? " cert-on" : ""}`}
                                                onClick={(e) => { e.stopPropagation(); this.handleAssignedToggle(doc); }}
                                            >
                                                <i className="fas fa-certificate" />
                                            </button>
                                            <i className="fas fa-file-alt ade-drl-doc-icon" />
                                            <span className="ade-drl-doc-name">{doc}</span>
                                        </div>

                                        {/* Submitted Checkbox */}
                                        <div className="ade-drl-check">
                                            <label className={`ade-row-cb-wrap${!isAssigned ? " cb-off" : ""}`}>
                                                <input
                                                    type="checkbox"
                                                    checked={isCollected}
                                                    onChange={() => isAssigned && this.handleCollectedToggle(doc)}
                                                    disabled={!isAssigned}
                                                />
                                                <span className={`ade-row-cb-box${isCollected ? " cb-green" : ""}`}>
                                                    {isCollected && <i className="fas fa-check" />}
                                                </span>
                                            </label>
                                        </div>

                                        {/* Comment */}
                                        <div className="ade-drl-comment">
                                            <input
                                                className="ade-drl-inp"
                                                type="text"
                                                placeholder="Add comment..."
                                                value={status.collected_comments || ""}
                                                disabled={!isAssigned}
                                                onChange={(e) => this.handleCommentChange(doc, "collected_comments", e.target.value)}
                                            />
                                        </div>

                                        {/* Status Badge */}
                                        <div className="ade-drl-status">
                                            {isReturned ? (
                                                <span className="ade-row-badge sb-blue">
                                                    <i className="fas fa-reply" /> Returned
                                                </span>
                                            ) : isCollected ? (
                                                <span className="ade-row-badge sb-green">
                                                    <i className="fas fa-check-circle" /> Submitted
                                                </span>
                                            ) : isAssigned ? (
                                                <span className="ade-row-badge sb-orange">
                                                    <i className="fas fa-clock" /> Pending
                                                </span>
                                            ) : null}
                                        </div>

                                        {/* Return Column — Edit Mode Only */}
                                        {editMode && (
                                            <div className="ade-drl-return">
                                                {isCollected && (
                                                    <div className="ade-drl-return-row">
                                                        <label className="ade-row-cb-wrap">
                                                            <input
                                                                type="checkbox"
                                                                checked={isReturned}
                                                                onChange={() => this.handleReturnedToggle(doc)}
                                                            />
                                                            <span className={`ade-row-cb-box${isReturned ? " cb-blue" : ""}`}>
                                                                {isReturned && <i className="fas fa-check" />}
                                                            </span>
                                                        </label>
                                                        {isReturned && (
                                                            <input
                                                                className="ade-drl-inp return-inp"
                                                                type="text"
                                                                placeholder="Return comment..."
                                                                value={status.return_comments}
                                                                onChange={(e) => this.handleCommentChange(doc, "return_comments", e.target.value)}
                                                            />
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        )}

                                    </div>
                                );
                            })}

                        </div>

                    </div>}

                </div>

                {/* ── FOOTER ── */}
                <div className="ade-footer">
                    <button className="ade-cancel-btn" onClick={onHide}>
                        Cancel
                    </button>
                    <button
                        className="ade-save-btn"
                        onClick={this.handleSave}
                        disabled={saving || (!editMode && !!duplicateStudentError)}
                        style={(saving || (!editMode && duplicateStudentError)) ? { opacity: 0.55, cursor: 'not-allowed' } : {}}
                        title={!editMode && duplicateStudentError ? 'Cannot save: duplicate student entry' : ''}
                    >
                        <i className={`fas ${saving ? 'fa-spinner fa-spin' : editMode ? 'fa-sync-alt' : 'fa-save'}`} />
                        {saving ? 'Saving…' : editMode ? 'Update Entry' : 'Save Entry'}
                    </button>
                </div>

            </>
        );

        if (inline) {
            return <div className="ade-inline-wrap">{body}</div>;
        }

        return (
            <Modal
                show={show}
                onHide={onHide}
                centered
                size="xl"
                dialogClassName="ade-modal"
            >
                {body}
            </Modal>
        );

    }

}

export default compose(
    withRouter,
    withApollo
)(AddEntryModal);
